import { Component } from '@angular/core';
import { Products } from './core/models/ProductType';
import { AbstractUserProvider } from '@skykick/platform-identity-auth-auth0-angular';
import { getFlattenedPermissionName, NavigationPermission } from '@skykick/core';

@Component({
  selector: 'sk-notifications-admin-center',
  templateUrl: './notifications-admin-center.component.html',
  styleUrl: './notifications-admin-center.component.scss'
})
export class NotificationsAdminCenterComponent {
  constructor(private readonly abstractUserProvider: AbstractUserProvider) {
  }

  products = Products.filter(x => this
    .abstractUserProvider
    .getCurrentUser()
    .hasPermission(getFlattenedPermissionName(x.navigationArea, NavigationPermission.FullAccess)));
}
